import { z } from 'zod';

import { InstanceIdType } from '#schema/defs';

export const CogniteVisualizableModel = z.object({
  ...InstanceIdType.shape,

  object3D: InstanceIdType.optional(),
});

export type CogniteVisualizableModelInput = z.input<typeof CogniteVisualizableModel>;
export type CogniteVisualizableModelOutput = z.output<typeof CogniteVisualizableModel>;
